import type {
  BulkRevisionSendEditDisplayItem,
  BulkRevisionSendEditTableItem,
  BulkRevisionSendEditTableList,
} from '@/views/product/BulkRevisionSendEdit/types'

export enum HandleFlag {
  CHANGE = 'change',
  ADD = 'add',
  INIT = 'init'
}
export interface State {
  //画面表示用データ
  bulkRevisionSendEditDisplayItem: BulkRevisionSendEditDisplayItem
  bulkRevisionSendEditTableList: BulkRevisionSendEditTableList
  //送信先変更か追加のフラグ
  handleFlag: HandleFlag
  //一括改版送信の編集画面で選択したデータ
  selectedItem: BulkRevisionSendEditTableItem
}

const state = (): State => ({
  bulkRevisionSendEditDisplayItem: {} as BulkRevisionSendEditDisplayItem,
  bulkRevisionSendEditTableList: [] as BulkRevisionSendEditTableList,
  handleFlag: HandleFlag.INIT,
  selectedItem: {} as BulkRevisionSendEditTableItem,

})

export default state
